// Money cell — mono tabular, USD subscript, optional compact form.
// Mirrors gastos-v2/primitives.jsx MoneyCell.
'use client';

import { fmtMoney, type Currency } from './moneyHelpers';

export function MoneyCell({
  amount,
  currency = 'MXN',
  compact = false,
  dim = false,
}: {
  amount: number;
  currency?: Currency;
  compact?: boolean;
  dim?: boolean;
}) {
  return (
    <span
      style={{
        fontFamily: 'var(--font-mono)',
        fontSize: '12px',
        fontVariantNumeric: 'tabular-nums',
        color: dim ? 'var(--ink-4)' : 'var(--ink)',
        whiteSpace: 'nowrap',
      }}
    >
      {fmtMoney(amount, currency, { compact })}
      {currency === 'USD' && (
        <span
          style={{
            fontSize: '10.5px',
            color: 'var(--ink-4)',
            marginLeft: '3px',
            letterSpacing: '0.4px',
          }}
        >
          USD
        </span>
      )}
    </span>
  );
}
